import React from "react"
import styled from "@emotion/styled"
import { css } from "@emotion/react"

import { color, fontFamily, width, mq } from "../../utils/style-components"

import HexBg from "../../img/common/hex_bg.svg"

const ContentWrap = styled.div`
  position: relative;
  background: top left / 461px 180px url(${HexBg}) ${color.white};
  ${mq(
    `pc`,
    css`
      margin: 19.84vw 0 0;
      clip-path: polygon(0 10vw, 100% 0, 100% 100%, 0 100%);
      padding-top: 12vw;
    `
  )}
  ${mq(
    `sp`,
    css`
      margin: 50vh 0 0;
      clip-path: polygon(0 30vh, 100% 0, 100% 100%, 0 100%);
      padding-top: 22vh;
    `
  )}
`

export const HeroBGStyle = css`
  display: block;
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
`

type SubpageContentProps = {
  title: string
  subtitle?: string
  className?:string
}

const SubpageContent: React.FC<SubpageContentProps> = ({
  title,
  subtitle = "",
  className = "",
  children,
}) => {
  return (
    <ContentWrap className={className}>
      <div
        css={css`
          position: relative;
          max-width: ${width.contentInner};
          width: ${width.contentSP};
          margin: 0 auto;
        `}
      >
        <h2
          css={css`
            color: ${color.blue};
            ${mq(
              `sp`,
              css`
                text-align: right;
              `
            )}
          `}
        >
          <div
            css={css`
              font-weight: 500;
              height: 2em;
              ${mq(
                `pc`,
                css`
                  font-size: 1.8rem;
                `
              )}
              ${mq(
                `sp`,
                css`
                  font-size: 1.4rem;
                `
              )}
            `}
          >
            {subtitle}
          </div>
          <div
            css={css`
              font-family: ${fontFamily.decorate1};
              font-weight: 500;
              line-height: 1;
              letter-spacing: 0.1em;
              text-shadow: 3px 3px 6px rgba(0, 0, 0, 0.16);
              ${mq(
                `pc`,
                css`
                  font-size: 8rem;
                `
              )}
              ${mq(
                `sp`,
                css`
                  font-size: 4.2rem;
                `
              )}
            `}
          >
            {title}
          </div>
        </h2>
      </div>
      {children}
    </ContentWrap>
  )
}

export default SubpageContent
